import { DefaultButton, FontSizes, IButtonProps, mergeStyleSets } from '@fluentui/react';
import ButtonTooltip, { TooltipItem } from '@v2/components/base/ButtonTooltip';
import React from 'react';


export interface DefaultButtonExProps extends IButtonProps {
  tooltip?: TooltipItem[];
  error?: string;
  className?: string;
}

const classNames = mergeStyleSets({
  root: {
    width: '100%',
    selectors: {
      '& > button': {
        width: '100%',
      },
      '& > div': {
        width: '100%',
      },
      '& > div > span': {
        width: '100%',
      },
      '& button:first-child': {
        flex: '1 0 auto',
      },
    },
  },

  errorMessage: {
    display: 'block',
    color: '#a4262c',
    fontSize: FontSizes.small,
    textAlign: 'center',
    width: '100%',
    marginTop: '4px',
  },
});

const DefaultButtonEx: React.FC<DefaultButtonExProps> = ({ className, tooltip, error, ...props }) => {
  return (
    <ButtonTooltip content={tooltip}>
      <div className={`${classNames.root} ${className || ''}`}>
        <DefaultButton {...props} />
        {!!error && <span className={classNames.errorMessage}>{error}</span>}
      </div>
    </ButtonTooltip>
  );
};

export default DefaultButtonEx;
